import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { FormControl, FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Endpoints } from '@huge-monorepo/portal/config';
import { GenericService,  } from '@huge-monorepo/portal/services';
import { UserRightsService } from 'libs/portal/src/services/user-rights/user-rights.service';

@Component({
  selector: 'app-alert-card',
  templateUrl: './alert-card.component.html',
  styleUrls: ['./alert-card.component.scss'],
})
export class AlertCardComponent implements OnInit {
	@Input() alertTypes: any[];
	@Input() alertSettings: any[];
	@Input() disabled = false;
	@Output() settingAdded: EventEmitter<any> = new EventEmitter();
	group: any;
	data: any[] = [];
	email = "";
	recipientEmails: any[] = [];
	emailFormGroup = new FormGroup({});
	notificationsToggleFormGroup = new FormGroup({});
	originalCapValue: number;
	originalIsMonthlyCapped: boolean = true;
	isLoaded = false;
	usagePerDeviceCapForm = new FormGroup({cap: new FormControl(0, [Validators.required, Validators.min(1)])});
	showValidationError1 = false;
isMonthlyCappedControl = new FormControl(true);

constructor(private auth: UserRightsService, private db: GenericService, private endpoints: Endpoints) {}

getAlertTypeName(typeId: number) {
  return this.alertTypes.filter((x) => x.ID == typeId)[0].Name;
}

	addSetting(alertSetting: any, isRemoved: boolean) {
		if (alertSetting.RecipientEmails == null) {
			alertSetting.RecipientEmails = [];
		}
		if (
			!this.emailFormGroup.get(alertSetting.EmailFormControl).errors ||
			!this.emailFormGroup.get(alertSetting.EmailFormControl).hasError("required")
		) {
			if (!isRemoved && this.emailFormGroup.get(alertSetting.EmailFormControl).value !== "") {
				alertSetting.RecipientEmails.push(this.emailFormGroup.get(alertSetting.EmailFormControl).value);
				this.emailFormGroup.get(alertSetting.EmailFormControl).setValue("");
			}


			var alertObj = {
				Id: alertSetting.SettingId,
				TypeID: alertSetting.TypeID,
				RecipientEmails: alertSetting.RecipientEmails,
				Enabled: this.notificationsToggleFormGroup.get(alertSetting.ToggleFormControl).value,
				AccessGroupID: alertSetting.AccessGroupID,
			};
			
			if(alertSetting.TypeID == 4){
				if(!this.usagePerDeviceCapForm.get("cap").valid){
					return;
				}
        // TODO: fix toast service
				// this.toastService.info("This may take a moment to take effect", 2000);
				this.originalCapValue = this.usagePerDeviceCapForm.get("cap").value;
				alertObj["CapSettings"] = {
					MonthlyCapping: this.isMonthlyCappedControl.value,
					FixedCapping: !this.isMonthlyCappedControl.value,
					CapValue: +(this.usagePerDeviceCapForm.get("cap").value * 1000000),
					Active: this.notificationsToggleFormGroup.get(alertSetting.ToggleFormControl).value,
				}
			}

			this.settingAdded.emit(alertObj);
		}
	}

	ngOnInit() {
		this.db.GET(this.endpoints.GET_PORTAL_ACCESS_GROUP(this.auth.GetGroupID())).subscribe({
			next: (res) => {
				this.group = res["body"];
				this.setupPage();
			}
		})
	}

	setupPage(): void {
		if (this.alertTypes != null) {
			if (this.alertSettings != null) {
				this.alertSettings.forEach((element, index) => {
					var alert = {
						SettingId: element.ID,
						AlertTypeName: this.getAlertTypeName(element.TypeID),
						TypeID: element.TypeID,
						Enabled: element.Enabled,
						AccessGroupID: this.auth.GetGroupID(),
						RecipientEmails: element.RecipientEmails,
						EmailFormControl: `emailControl${index}`,
						ToggleFormControl: `notificationsToggleControl${index}`,
					};
					if(element.TypeID == 4){
						if (element["CapSettings"]) {
							this.originalCapValue = element["CapSettings"]["CapValue"] / 1000000;
							this.usagePerDeviceCapForm.get("cap").setValue(this.originalCapValue);
							alert.Enabled = element["CapSettings"]["Active"];
							this.isMonthlyCappedControl.setValue(element['CapSettings']['MonthlyCapping']);
							this.originalIsMonthlyCapped = element['CapSettings']['MonthlyCapping'];
						}
						if(this.group.CanEnableCapping !== true){
							return;
						}
					}
					this.notificationsToggleFormGroup.addControl(
						`notificationsToggleControl${index}`,
						new FormControl(alert.Enabled, []),
					);
					this.emailFormGroup.addControl(`emailControl${index}`, new FormControl("", [Validators.email]));
					
					this.data.push(alert);
				});
			} else {
				if (this.disabled) {
					this.notificationsToggleFormGroup.disable();
					this.emailFormGroup.disable();
					this.isLoaded = true;
					return;
				}
				this.alertTypes.forEach((element, count) => {
					this.emailFormGroup.addControl(`emailControl${count}`, new FormControl("", [Validators.email]));
					this.notificationsToggleFormGroup.addControl(
						`notificationsToggleControl${count}`,
						new FormControl(false, []),
					);
					const setting = {
						Id: 0,
						AlertTypeName: element.Name,
						TypeID: element.ID,
						Enabled: false,
						AccessGroupID: this.auth.GetGroupID(),
						RecipientEmails: [],
						EmailFormControl: `emailControl${count}`,
						ToggleFormControl: `notificationsToggleControl${count}`,
					};
					this.data.push(setting);

					const alertObj = {
						Id: setting.Id,
						TypeID: setting.TypeID,
						RecipientEmails: [],
						Enabled: false,
						AccessGroupID: setting.AccessGroupID,
					};

					this.settingAdded.emit(alertObj);
				});
				this.reload();
			}

			this.isLoaded = true;
			if (this.disabled) {
				this.notificationsToggleFormGroup.disable();
				this.emailFormGroup.disable();
			}
		}
	}

	reload() {
		location.reload();
	}

	removeRecipient(alertSetting: any, index: number) {
		alertSetting.RecipientEmails.splice(index, 1);
		this.addSetting(alertSetting, true);
	}

	resetCapValue(){
		this.usagePerDeviceCapForm.get('cap').setValue(this.originalCapValue);
	}
}
